import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export const extractPropertyFromArray = (propertyName: string) => <T>(obs$: Observable<object[]>): Observable<T[]> => obs$.pipe(
  map((wrapper = []) => wrapper.map(item => item[propertyName])),
);

export const isItemInArray = <T>(item$: Observable<T>, list$: Observable<T[]>, propertyName: string = 'id'): Observable<boolean> =>
  combineLatest([list$, item$]).pipe(
    map(([list, item]) => Boolean(item) && list && list.length > 0 && list.some(i => i[propertyName] === item[propertyName])),
  );

export const sortAlphabetically = (propertyName: string = 'name') => (list: object) => Object.values(list)
  .sort((a, b) => a[propertyName] < b[propertyName] ? -1 : 1);

export const toArray = <T>(obs$: Observable<{ [key: string]: T }>): Observable<T[]> => obs$.pipe(map(Object.values));

export const removeDuplicates = <T, U>(prop = 'id', set = new Set()) =>
  (acc: U[], item: T) => {
    if (set.has(item[prop])) {
      return acc;
    }
    set.add(item[prop]);
    return [...acc, item];
  };
